import {
  DataModuleEntityRaw,
  dataModuleEntityRaw,
} from '@edgvr-front/data/domain';
import { Validate } from '@edgvr-front/util/validate';

export class DataModuleGetResponseDTO {
  private static validation = Validate.compile(
    DataModuleGetResponseDTO.validationSchema()
  );

  constructor(readonly data: DataModuleGetResponseDTORaw) {
    Validate.assert(DataModuleGetResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: ['dataModule'],
      properties: {
        dataModule: dataModuleEntityRaw,
      },
    };
  }
}

interface DataModuleGetResponseDTORaw {
  dataModule: DataModuleEntityRaw;
}
